"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var tournament_api_1 = require("@l2p/tournament-api");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var FirstPlace_1 = __importDefault(require("./places/FirstPlace"));
var SecondPlace_1 = __importDefault(require("./places/SecondPlace"));
var ThirdPlace_1 = __importDefault(require("./places/ThirdPlace"));
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var apps_shared_1 = require("@l2p/apps-shared");
var PrizesTable_1 = __importDefault(require("./PrizesTable"));
var utils_1 = require("../../../utils");
var TournamentPrizes = function (_a) {
    var prizes = _a.prizes, userConfirmed = _a.userConfirmed, tournamentId = _a.tournamentId, isFinished = _a.isFinished;
    var t = (0, next_intl_1.useTranslations)('translation');
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var signUpNavigate = (0, apps_shared_1.useOpenSignUp)();
    var sortedPrizes = (0, react_1.useMemo)(function () {
        return prizes === null || prizes === void 0 ? void 0 : prizes.sort(function (a, b) { return Number(a === null || a === void 0 ? void 0 : a.position) - Number(b === null || b === void 0 ? void 0 : b.position); });
    }, [prizes]);
    var loyaltyBonuses = (0, swr_hooks_1.useLoyaltyBonuses)().data;
    var preparedPrizes = (0, utils_1.generatePrizeTable)({
        prizes: sortedPrizes || [],
        currency: currentCurrency,
        bonuses: loyaltyBonuses || [],
    });
    var _b = (0, swr_hooks_1.useJoinTournament)(), joinTournament = _b.joinTournament, isSubmitting = _b.isSubmitting;
    var participate = (0, react_1.useCallback)(function (id) {
        if (!isAuth)
            return signUpNavigate();
        if (id)
            joinTournament({ id: id });
    }, [joinTournament, signUpNavigate, isAuth]);
    var getPrizeFromBonus = (0, react_1.useCallback)(function (bonus) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return ((_a = bonus === null || bonus === void 0 ? void 0 : bonus.value) === null || _a === void 0 ? void 0 : _a.bonus) ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.pointsColumn },
            react_1.default.createElement("div", null, "".concat(((_b = bonus === null || bonus === void 0 ? void 0 : bonus.value) === null || _b === void 0 ? void 0 : _b.bonus.percents) || '', " ").concat(((_d = (_c = bonus === null || bonus === void 0 ? void 0 : bonus.value) === null || _c === void 0 ? void 0 : _c.bonus) === null || _d === void 0 ? void 0 : _d.amount) ? (_f = (_e = bonus === null || bonus === void 0 ? void 0 : bonus.value) === null || _e === void 0 ? void 0 : _e.bonus) === null || _f === void 0 ? void 0 : _f.amount : '', " ").concat(((_h = (_g = bonus === null || bonus === void 0 ? void 0 : bonus.value) === null || _g === void 0 ? void 0 : _g.bonus) === null || _h === void 0 ? void 0 : _h.freespins)
                ? ((_k = (_j = bonus === null || bonus === void 0 ? void 0 : bonus.value) === null || _j === void 0 ? void 0 : _j.bonus) === null || _k === void 0 ? void 0 : _k.amount)
                    ? '+ '
                    : '' + ((_l = bonus === null || bonus === void 0 ? void 0 : bonus.value) === null || _l === void 0 ? void 0 : _l.bonus.freespins) + t('fs')
                : '')))) : null;
    }, [t]);
    var getPrize = (0, react_1.useCallback)(function (prize) {
        var _a;
        if (!prize)
            return null;
        if (prize.type === tournament_api_1.TournamentRewardType.Balance) {
            var cash = (_a = prize === null || prize === void 0 ? void 0 : prize.amount) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.currency === currentCurrency; });
            if (cash)
                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.pointsColumn },
                    react_1.default.createElement("div", null, cash.amount),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.pointsText }, currentCurrency)));
        }
        if (prize.type === tournament_api_1.TournamentRewardType.FreeRounds && prize.value)
            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.pointsColumn },
                react_1.default.createElement("div", null, prize.value),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.pointsText }, t('fs').toLocaleUpperCase())));
        if (prize.type === tournament_api_1.TournamentRewardType.LoyalityExp && prize.value)
            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.pointsColumn },
                react_1.default.createElement("div", null, prize.value),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.pointsText }, t('loyalExp').toLocaleUpperCase())));
        if (prize.type === tournament_api_1.TournamentRewardType.Physical && prize.physicalReward)
            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.pointsColumn },
                react_1.default.createElement("div", null, prize.physicalReward)));
        if (prize.type === tournament_api_1.TournamentRewardType.Physical && prize.physicalReward)
            return (react_1.default.createElement("div", { className: styles_module_scss_1.default.pointsColumn },
                react_1.default.createElement("div", null, prize.physicalReward)));
        return null;
    }, [currentCurrency, t]);
    var firstPrize = (0, react_1.useMemo)(function () {
        if (!(sortedPrizes === null || sortedPrizes === void 0 ? void 0 : sortedPrizes[0]))
            return null;
        var prize = getPrize(sortedPrizes === null || sortedPrizes === void 0 ? void 0 : sortedPrizes[0]);
        if (prize)
            return prize;
        return getPrizeFromBonus(preparedPrizes === null || preparedPrizes === void 0 ? void 0 : preparedPrizes[0]);
    }, [preparedPrizes, sortedPrizes, getPrizeFromBonus, getPrize]);
    var secondPrize = (0, react_1.useMemo)(function () {
        if (!(sortedPrizes === null || sortedPrizes === void 0 ? void 0 : sortedPrizes[1]))
            return null;
        var prize = getPrize(sortedPrizes === null || sortedPrizes === void 0 ? void 0 : sortedPrizes[1]);
        if (prize)
            return prize;
        return getPrizeFromBonus(preparedPrizes === null || preparedPrizes === void 0 ? void 0 : preparedPrizes[1]);
    }, [preparedPrizes, sortedPrizes, getPrizeFromBonus, getPrize]);
    var thirdPrize = (0, react_1.useMemo)(function () {
        if (!(sortedPrizes === null || sortedPrizes === void 0 ? void 0 : sortedPrizes[2]))
            return null;
        var prize = getPrize(sortedPrizes === null || sortedPrizes === void 0 ? void 0 : sortedPrizes[2]);
        if (prize)
            return prize;
        return getPrizeFromBonus(preparedPrizes === null || preparedPrizes === void 0 ? void 0 : preparedPrizes[2]);
    }, [preparedPrizes, sortedPrizes, getPrizeFromBonus, getPrize]);
    if (!sortedPrizes || sortedPrizes.length === 0)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("h2", { className: styles_module_scss_1.default.title }, t('tournamentPrizes')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.places },
            react_1.default.createElement(SecondPlace_1.default, null),
            react_1.default.createElement(FirstPlace_1.default, null),
            react_1.default.createElement(ThirdPlace_1.default, null)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.points },
            firstPrize,
            secondPrize,
            thirdPrize),
        react_1.default.createElement(PrizesTable_1.default, { prizes: sortedPrizes.slice(3) }),
        !isFinished && !userConfirmed && (react_1.default.createElement("div", { className: styles_module_scss_1.default.participateContainer },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", height: "50px", maxWidth: "100%", loading: isSubmitting, onClick: function () { return participate(tournamentId); } }, t('joinNow'))))));
};
exports.default = TournamentPrizes;
